import { Observer } from 'mobx-react-lite';
import React from 'react';
import { isObject, isString } from '../../utils/typeChecks.utils';
var ErrorListItem = function (props) {
    return React.createElement(Observer, { children: function () { return (React.createElement("span", { className: "ErrorListItem" },
            isNaN(+props.e[0]) && React.createElement(React.Fragment, null,
                React.createElement("strong", null, props.e[0]),
                ": "),
            isString(props.e[1]) ? React.createElement("span", null, props.e[1]) : isObject(props.e[1]) ? React.createElement(ErrorList, { errors: props.e[1] }) : props.e[1] + '')); } });
};
var ErrorList = function (props) {
    return React.createElement(Observer, { children: function () {
            var array = Object.entries(props.errors);
            return (array.length === 1 ? React.createElement(ErrorListItem, { e: array[0] }) :
                React.createElement("ul", { className: "ErrorList" }, array.map(function (d, i) { return React.createElement("li", { key: i + d[0] },
                    React.createElement(ErrorListItem, { e: d })); })));
        } });
};
export default ErrorList;
